import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function createDateRangeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const start: Date = control.get('startDate')?.value;
    const end: Date = control.get('endDate')?.value;

    if (start && end && !isNaN(start.getTime()) && !isNaN(end.getTime())) {
      const isRangeValid = end.getTime() - start.getTime() > 0;

      return isRangeValid ? null : { dateRange: true };
    }

    return null;
  };
}
